

export const Vars = {

    // Responsive
    DESKTOP_MIN_WITDTH:      992,
    DESKTOP_MIN_WIDTH:      992,
    MINI_MAX_WITDTH:    500,

    // dropdown heights
    DROPDOWN_HT_PINBOARD: 141,
    DROPDOWN_HT_FEED: 305,
    DROPDOWN_HT_FOLDER: 223,
    DROPDOWN_HT_FOLLOWING_SETTING: 372,
    DROPDOWN_HT_ALL: 86,
    DROPDOWN_HT_FAVORITE: 86,
}


export const COOKIE_NAME = {
    PLAYLIST: 'fs_playlist',
    NEW_USER: 'fsnewuser'
}